/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Type_LabelInputs */

const en_edit_event_group_type_label = /** @type {(inputs: Edit_Event_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Type`)
};

const fr_edit_event_group_type_label = /** @type {(inputs: Edit_Event_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de groupe`)
};

const de_edit_event_group_type_label = /** @type {(inputs: Edit_Event_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppentyp`)
};

const it_edit_event_group_type_label = /** @type {(inputs: Edit_Event_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di gruppo`)
};

const ru_edit_event_group_type_label = /** @type {(inputs: Edit_Event_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип группы`)
};

const es_edit_event_group_type_label = /** @type {(inputs: Edit_Event_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de grupo`)
};

const zh_cn2_edit_event_group_type_label = /** @type {(inputs: Edit_Event_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组类型`)
};

const ja_edit_event_group_type_label = /** @type {(inputs: Edit_Event_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループタイプ`)
};

const hi_edit_event_group_type_label = /** @type {(inputs: Edit_Event_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह प्रकार`)
};

const pt_pt2_edit_event_group_type_label = /** @type {(inputs: Edit_Event_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de grupo`)
};

/**
* | output |
* | --- |
* | "Group Type" |
*
* @param {Edit_Event_Group_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_type_label = /** @type {((inputs?: Edit_Event_Group_Type_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Type_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_type_label(inputs)
	if (locale === "de") return de_edit_event_group_type_label(inputs)
	if (locale === "it") return it_edit_event_group_type_label(inputs)
	if (locale === "ru") return ru_edit_event_group_type_label(inputs)
	if (locale === "es") return es_edit_event_group_type_label(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_type_label(inputs)
	if (locale === "ja") return ja_edit_event_group_type_label(inputs)
	if (locale === "hi") return hi_edit_event_group_type_label(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_type_label(inputs)
	return en_edit_event_group_type_label(inputs)
});